<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="container-fluid">
    <div class="row">
        <div class="alignMenu shadow text-left pt-2 px-1" [ngClass]="companyId == 36 ? 'col-md-3 col-lg-2' : 'col-lg-2 col-xl-2'">
            <app-rental-menu (companyIdSevenMile)="companyIdSevenMile($event)"></app-rental-menu>
        </div>
        <div class="bgMainSection bgBlue text-left" [ngClass]="companyId == 36 ? 'col-md-9 col-lg-10' : 'col-lg-10 col-xl-10'">
            <div class="container">
                <div class="row">
                    <div class="col-5 text-left mt-4">
                        <h2 class="mainHeading">Vendor Registration</h2>
                    </div>
                    <div class="col-7 text-right mt-4" [ngClass]="{'col-lg-5': SwapORamaCustomChanges}">
                        <h1 class="mainHeading">{{marketName}}</h1>
                    </div>
                    <div class="col-12 col-lg-2 text-left text-lg-right mt-4" *ngIf="SwapORamaCustomChanges">
                        <a class="text-white language-toggle translator" style="text-decoration: none !important;" translate="no" href="javascript:void(0)" onclick="toggleLanguage()">Español</a>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left">
                        <button #btnContact class="btn btnMain mr-3 mt-2" routerLinkActive="activeTab">Contact
                            Information</button>
                        <button #btnOnlineAccess class="btn btnMain mr-3 mt-2" routerLinkActive="activeTab">Online
                            Access</button>
                        <button #btnPayment class="btn btnMain mt-2"
                            *ngIf="this.registrationFee.RegistrationFee!==0 && this.registrationFee.ChargeVendorRegistration">Payment</button>
                    </div>
                </div>
                <div #divContactInfo class="bgWghite shadow pt-2 mt-2"
                    [ngStyle]="{ display: showContactInfo ? 'block' : 'none' }">
                    <div class="container" [formGroup]="VendorForm">
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3 pt-3">
                                <label for="txtFirstName" i18n>*First Name</label>
                                <input id="txtFirstName" class="form-control" type="text" #VendorFirstName
                                    formControlName="FirstName" required [appAutoCase]="formatId">
                                <small style="color: #D7232C;" *ngIf="VendorForm.get('FirstName').hasError('required')"
                                    i18n>* required </small>
                                <small style="color: #D7232C;" *ngIf="VendorForm.get('FirstName').hasError('maxlength')"
                                    i18n>* max length exceeded
                                </small>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3 pt-3"
                                *ngIf="this.VendorGeneralSetting.VendorNameFormat.includes('Middle Name')">
                                <label for="txtMiddleName" i18n>Middle Name</label>
                                <input id="txtMiddleName" class="form-control" type="text" formControlName="MiddleName"
                                    [appAutoCase]="formatId">
                                <small style="color: #D7232C;" *ngIf="VendorForm.get('MiddleName').hasError('maxlength')"
                                    i18n>* max length exceeded
                                </small>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3 pt-3"
                                *ngIf="this.VendorGeneralSetting.VendorNameFormat.includes('Last Name')">
                                <label for="txtLastName" i18n><span *ngIf="LastNameMandatory">*</span>Last Name</label>
                                <input id="txtLastName" class="form-control" type="text" formControlName="LastName"
                                    [appAutoCase]="formatId">
                                <small style="color: #D7232C;" *ngIf="VendorForm.get('LastName').hasError('maxlength')"
                                    i18n>* max length exceeded
                                </small>
                                <small style="color: #D7232C;" *ngIf="VendorForm.get('LastName').hasError('required')"
                                    i18n>* required </small>
                            </div>

                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                <div>
                                    <label class="mb-0"><span *ngIf="AddressMandatory">*</span>Address</label>
                                    <input id="txtAddress" class="form-control" type="text" formControlName="Address">
                                    <small style="color: #D7232C;" *ngIf="VendorForm.get('Address').hasError('maxlength')"
                                        i18n>* max length exceeded </small>
                                    <small style="color: #D7232C;" *ngIf="VendorForm.get('Address').hasError('required')"
                                        i18n>* required </small>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                <div>
                                    <label class="mb-0"><span *ngIf="AddressMandatory">*</span>City</label>
                                    <input id="txtCity" class="form-control" type="text" formControlName="City"
                                        [appAutoCase]="caseCode">
                                    <small style="color: #D7232C;" *ngIf="VendorForm.get('City').hasError('required')"
                                        i18n>* required </small>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                <div>
                                    <span class="mb-0"><span *ngIf="AddressMandatory">*</span>State/ Province</span>

                                    <ejs-combobox id='StateCombobox' #State *ngIf="showStateDropDown"
                                        [fields]='DropDownfieldsState' [dataSource]='StateList' formControlName="State"
                                        [allowFiltering]='true' allowCustom=true
                                        [placeholder]="'Select State'" (created)="lockStateComboBoxTranslation()" (open)="lockStateComboBoxTranslation()"></ejs-combobox>

                                    <input type="text" *ngIf="!showStateDropDown" maxlength="2" class="form-control"
                                        formControlName="State">

                                    <small style="color: #D7232C;" *ngIf="VendorForm.get('State').hasError('required')"
                                        i18n>* required </small>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                <div>
                                    <label class="mb-0">*Country</label>
                                    <select id="ddlCountry" class="form-control" formControlName="CountryCode"
                                        tabindex="11" (change)="DropDownCountryChange($event)">
                                        <option *ngFor="let ct of countryList" [value]="ct.Code">{{ct.Name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                <div>
                                    <span class="mb-0"><span *ngIf="AddressMandatory">*</span>Zip/Postal Code</span>
                                    <!-- <ejs-maskedtextbox [mask]="ZipCodeMask" tabindex="13" name="ZipCode" id="ZipCode"
                                        formControlName="ZipCode"></ejs-maskedtextbox> -->
                                    <ejs-maskedtextbox [mask]="ZipCodeMask" *ngIf="showZipCodeAsTxt" name="ZipCode"
                                        id="ZipCode" formControlName="ZipCode"
                                        (blur)="UpdateStateAndCityByZipcode()"></ejs-maskedtextbox>
                                    <input type="text" *ngIf="!showZipCodeAsTxt" class="form-control"
                                        formControlName="ZipCode" (blur)="UpdateStateAndCityByZipcode()">

                                    <small style="color: #D7232C;" *ngIf="VendorForm.get('ZipCode').hasError('required')"
                                        i18n>* required </small>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                <div>
                                    <label class="mb-0"><span *ngIf="WorkPhoneMandatory">*</span>Work Phone</label>
                                    <ejs-maskedtextbox [mask]="PhoneNumberMask" tabindex="13" name="WorkPhone"
                                        id="telephone" formControlName="WorkPhone"></ejs-maskedtextbox>
                                    <small style="color: #D7232C;" *ngIf="VendorForm.get('WorkPhone').hasError('required')"
                                        i18n>* required </small>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                <div>
                                    <label class="mb-0"><span *ngIf="CellPhoneMandatory">*</span>Cell Phone</label>
                                    <ejs-maskedtextbox [mask]="PhoneNumberMask" tabindex="13" name="telephone"
                                        id="telephone" formControlName="CellPhone"></ejs-maskedtextbox>
                                    <small style="color: #D7232C;" *ngIf="VendorForm.get('CellPhone').hasError('minlength')"
                                        i18n>* invalid Cell Phone Number</small>
                                    <small style="color: #D7232C;" *ngIf="VendorForm.get('CellPhone').hasError('required')"
                                        i18n>* required </small>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                <div>
                                    <label class="mb-0"><span *ngIf="EmailMandatory">*</span>Email</label>
                                    <input id="txtEmail" class="form-control" type="text" formControlName="Email">
                                    <small style="color: #D7232C;" *ngIf="VendorForm.get('Email').hasError('required')"
                                        i18n>* required </small>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                <div>
                                    <label class="mb-0"><span *ngIf="DriverLicenseNumberMandatory">*</span>Drivers
                                        License</label>
                                    <input id="txtDriverLicense" class="form-control" type="text"
                                        formControlName="DriverLicenseNumber">
                                    <small style="color: #D7232C;"
                                        *ngIf="VendorForm.get('DriverLicenseNumber').hasError('required')" i18n>*
                                        required </small>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                <div>
                                    <label class="mb-0"><span *ngIf="DLExpiryDateMandatory">*</span>DL Expiry
                                        Date</label>
                                    <!-- <ejs-datepicker format='MM/dd/yyyy' class="form-control" [allowEdit]=false
                                        formControlName="DLExpiryDate"
                                        i18n-placeholder="DL Expiry Date" placeholder="DL Expiry Date"></ejs-datepicker> -->
                                    <input type="date" class="form-control" formControlName="DLExpiryDate"
                                        [placeholder]="'DL Expiry Date'" i18n-placeholder="DL Expiry Date">
                                    <div>
                                        <small style="color: #D7232C;" *ngIf="VendorForm.get('DLExpiryDate').invalid" i18n>*
                                            required </small>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                <div>
                                    <label class="mb-0"><span *ngIf="DLStateMandatory">*</span>DL State</label>
                                    <ejs-combobox id='DLStateCombobox' #DLState *ngIf="showStateDropDown"
                                        [fields]='DropDownfieldsState' [dataSource]='StateList'
                                        formControlName="DLState" [allowFiltering]='true' allowCustom=true
                                        filterBarPlaceholder="Search for State/Province"
                                        [placeholder]="'Select State'" (created)="lockDLStateComboBoxTranslation()" (open)="lockDLStateComboBoxTranslation()"></ejs-combobox>

                                    <!-- <ejs-combobox id='StateCombobox' #DLState *ngIf="!showUsStateDropDown" [fields]='DropDownfieldsState' [dataSource]='NoneUsStateList' formControlName="DLState" [allowFiltering]='true'
                                                                    allowCustom=true placeholder = '' ></ejs-combobox> -->

                                    <input type="text" *ngIf="!showStateDropDown" maxlength="2" class="form-control"
                                        formControlName="DLState">
                                    <small style="color: #D7232C;" *ngIf="VendorForm.get('DLState').hasError('required')"
                                        i18n>*
                                        required </small>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3" *ngIf="SevenMileWRWarningMsg==false">
                                <div>
                                    <label class="mb-0"><span *ngIf="ResaleNumberMandatory">*</span>Resale #</label>
                                    <input id="txtResaleNumber" class="form-control" type="text"
                                        formControlName="ResaleNumber">
                                    <small style="color: #D7232C;"
                                        *ngIf="VendorForm.get('ResaleNumber')?.hasError('required')" i18n>* required
                                    </small>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                <div>
                                    <label class="mb-0"><span *ngIf="CompanyNameMandatory">*</span>Business Name</label>
                                    <input id="txtCompanyName" class="form-control" type="text"
                                        formControlName="CompanyName">
                                    <small style="color: #D7232C;"
                                        *ngIf="VendorForm.get('CompanyName').hasError('required')" i18n>*
                                        required </small>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                <div>
                                    <label class="mb-0"><span
                                            *ngIf="BusinessLicenseNumberMandatory">*</span>{{SevenMileWRWarningMsg?"Wisconsin Seller Permit (15 digits starting with 456)":"Business License #"}}</label>
                                    <input id="txtBusinessLicenseNumber" class="form-control" type="text"
                                        formControlName="BusinessLicenseNumber" [maxlength]="SevenMileWRWarningMsg?15:25">
                                    <small style="color: #D7232C;"
                                        *ngIf="VendorForm.get('BusinessLicenseNumber').hasError('required')" i18n>*
                                        required </small>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                <div>
                                    <label class="mb-0">* Primary Selling Product</label>
                                    <!-- <ejs-dropdownlist id="ProductPriority" [dataSource]="productList"
                                        [fields]="ProductDropDownfields" [popupHeight]="200" formControlName="ProductPriority"
                                        (valueChange)="primaryproductchange($event)"> -->
                                    <ejs-combobox id="ProductPriority" [dataSource]="productList" [allowCustom]="false"
                                        [fields]="ProductDropDownfields" [popupHeight]="200"
                                        formControlName="ProductPriority"
                                        (valueChange)="primaryproductchange($event)"></ejs-combobox>
                                    <small style="color: #D7232C;" *ngIf="VendorForm.get('ProductPriority').invalid" i18n>*
                                        required</small>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                <div>
                                    <label class="mb-0">*Vendor Type</label>
                                    <ejs-dropdownlist id="ddlType" [dataSource]="VendorTypeList"
                                        [fields]="{text:'VtyTxtVendorType',value:'VtyTxtVendorType'}"
                                        formControlName="VendorType" tabindex="11" placeholder="Select Vendor Type">

                                    </ejs-dropdownlist>
                                    <small style="color: #D7232C;" *ngIf="VendorForm.get('VendorType').invalid" i18n>*
                                        required</small>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3" *ngIf="!SevenMileWRWarningMsg">
                                <div>
                                    <label class="mb-0"><span
                                            *ngIf="SSNMandatory">*</span>SSN</label>
                                    <ejs-maskedtextbox id="txtSSN" [mask]="SSNMask " tabindex="13" name="txtSSN"
                                        formControlName="SSN"></ejs-maskedtextbox>
                                    <small style="color: #D7232C;" *ngIf="VendorForm.get('SSN').hasError('required')" i18n>*
                                        required </small>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3" *ngIf="SevenMileWRWarningMsg">
                                <div>
                                    <label class="mb-0"><span
                                            *ngIf="SSNMandatory">*</span>{{SevenMileWRWarningMsg?"Social Security Number (Last 4 digits)":"SSN"}}</label>
                                    <ejs-maskedtextbox id="txtSSN" [mask]="SevenMileWRWarningMsg ? SSNMask2 : SSNMask " tabindex="13" name="txtSSN"
                                        formControlName="ResaleNumber"></ejs-maskedtextbox>
                                    <small style="color: #D7232C;" *ngIf="VendorForm.get('ResaleNumber')?.hasError('required')" i18n>*
                                        required </small>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                <div>
                                    <label class="mb-0"><span
                                            *ngIf="TaxIDMandatory">*</span>{{SevenMileWRWarningMsg?"FEIN Number(Last 4 digits)":"Tax ID"}}</label>
                                    <input id="txtTaxID" class="form-control" type="text" formControlName="TaxID" maxlength="20"
                                        *ngIf="!SevenMileWRWarningMsg">
                                    <ejs-maskedtextbox id="txtTaxID" [mask]="FEINMask" tabindex="13" name="txtTaxID" formControlName="TaxID"
                                        *ngIf="SevenMileWRWarningMsg"></ejs-maskedtextbox>
                                    <small style="color: #D7232C;" *ngIf="VendorForm.get('TaxID').hasError('required')"
                                        i18n>*
                                        required </small>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-right mb-3">
                                <button class="btn btn-outline-primary mt-3 mr-2" (click)="Oncancel()">Cancel</button>
                                <button class="btn btn-primary mt-3" (click)="ValidationVendorDetails()">Next</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div #divOnlineAccess class="bgWghite shadow pt-2 mt-2"
                    [ngStyle]="{ display: showOnlineAccess ? 'block' : 'none' }">
                    <div class="container" [formGroup]="OnlineAccessForm">
                        <div class="row"
                            *ngIf="this.registrationFee.RegistrationFee!==0 && this.registrationFee.ChargeVendorRegistration">
                            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                <div>
                                    <label class="mb-0">*Registration Fee</label>
                                    <input id="txtRegistrationFee" class="form-control text-right" type="text"
                                        [disabled]="true" [value]="OnlineAccessForm.get('RegistrationFee').value">
                                </div>
                            </div>
                        </div>
                        <div *ngFor="let rule of rulesFormArray; let i = index">
                            <div class="row">
                                <div class="col-12 text-left mt-2">
                                    <div>
                                        <input type="checkbox" class="CheckboxClass mt-3" [formControlName]="isChecked"
                                            [id]="'checkbox_' + i" (change)="updateArrayDirectly(i, $event)">

                                        <label class="chkAlign mb-0" [for]="'checkbox_' + i">
                                            {{ rule.rulesAndRegualtions }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="rule.AgreementLinkRequired">
                                <div class="col-12 text-left mt-1">
                                    <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMS4xMjQiIGhlaWdodD0iMTUuODQzIiB2aWV3Qm94PSIwIDAgMjEuMTI0IDE1Ljg0MyI+CiAgPHBhdGggaWQ9Ikljb25fYXdlc29tZS1oYW5kLXBvaW50LXJpZ2h0IiBkYXRhLW5hbWU9Ikljb24gYXdlc29tZS1oYW5kLXBvaW50LXJpZ2h0IiBkPSJNMjEuMTI0LDEwLjFBMS44NiwxLjg2LDAsMCwxLDE5LjI3NiwxMS45aC00LjEyYTIuMDI5LDIuMDI5LDAsMCwxLS4yNiwyLjkyNywxLjg5LDEuODksMCwwLDEtLjY3OSwyLjU3MWMuMzcsMi4wMjctLjkwNSwyLjk0LTMsMi45NC0uMTEzLDAtLjU0OC0uMDA4LS42Ni0uMDA4LTIuNTU3LjAwNy0zLjE3Mi0xLjI4Mi01LjEtMS41ODFhLjk4OS45ODksMCwwLDEtLjgzNi0uOTc4VjEwLjdoMEExLjk4LDEuOTgsMCwwLDEsNS44LDguODljMS4xOTItLjUzNiwzLjkzNy0yLjAyMyw0LjQzNy0zLjE5YTEuNzU5LDEuNzU5LDAsMCwxLDEuNjUtMS4yQTEuOTgyLDEuOTgyLDAsMCwxLDEzLjcsNy4yNmE1LjYwOCw1LjYwOCwwLDAsMS0uNTg0LDEuMDI4aDYuMTU3QTEuODksMS44OSwwLDAsMSwyMS4xMjQsMTAuMVptLTE3LjE2My4wMTR2Ny45MjJhLjk5Ljk5LDAsMCwxLS45OS45OUguOTlhLjk5Ljk5LDAsMCwxLS45OS0uOTlWMTAuMTExYS45OS45OSwwLDAsMSwuOTktLjk5aDEuOThBLjk5Ljk5LDAsMCwxLDMuOTYxLDEwLjExMVpNMi44MDYsMTcuMDQyYS44MjUuODI1LDAsMSwwLS44MjUuODI1QS44MjUuODI1LDAsMCwwLDIuODA2LDE3LjA0MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTQuNSkiIGZpbGw9IiMwNzI4ZmYiLz4KPC9zdmc+Cg=="
                                        class="img-fluid" />
                                    &nbsp;<a [href]="rule.AgreementBlobURL" target="_blank"
                                        class="rules">{{rule.AgreementLinkTextContent}}</a>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-right mb-3">
                                <button class="btn btn-outline-primary mt-3 mr-1"
                                    (click)="displayContactInfo()">Back</button>
                                <button class="btn btn-outline-primary mt-3 mr-1" (click)="Oncancel()">Cancel</button>
                                <button class="btn btn-primary mt-3 mr-1" [disabled]="!allCheckboxesCheckedValidator()"
                                    (click)="OnVendorRegister($event)">Submit</button>
                                <!-- [disabled]="(this.registrationFee.RegistrationFee!==0 && this.registrationFee.ChargeVendorRegistration && !OnlineAccessForm.get('registrationPaymentCheck').value) || !OnlineAccessForm.get('registrationRuleReadCheck').value"  -->
                            </div>
                        </div>
                    </div>
                </div>
                <div #divRegisterPayment class="bgWghite shadow pt-2 mt-2" *ngIf="processPayment">
                    <app-payment [keyedInTransaction]="true" [isQDR]="IsQDR" [MarketId]="marketId"
                        [CCAmount]="registrationFee.RegistrationFee" [TransactionType]="transactionType"
                        [voidPayment]="false" [VerifoneId]="verifoneId" (ClosePaymentPage)="ClosePaymentPage()"
                        (PaymentResponse)="PaymentResponse($event)"></app-payment>
                </div>
                <div #divRegisterPayment class="bgWghite shadow pt-2 mt-2" *ngIf="voidPayment"
                    [ngStyle]="{ display: showregisterpayment ? 'block' : 'none' }">
                    <app-payment [keyedInTransaction]="true" [isQDR]="IsQDR" [MarketId]="marketId"
                        [CCAmount]="registrationFee.RegistrationFee" [TransactionType]="transactionType" [voidPayment]="voidPayment"
                        [VerifoneId]="verifoneId" (ClosePaymentPage)="ClosePaymentPage()"
                        (PaymentResponse)="voidPaymentResponse()"></app-payment>
                </div>
                <div #divRegisterPayment class="bgWghite shadow pt-2 mt-2" *ngIf="openConfirmationPage">
                    <app-registration-confirmation [VendorId]="vendorId" [newVendor]="false" [AccountReceipId]="AccountReceiptId" [verifoneId]="verifoneId==''? 0 : verifoneId"
                      [RentalType]="1"></app-registration-confirmation>
                </div>
            </div>
        </div>
    </div>
</div>
